import React, { useEffect } from "react";
import aboutBanner from "../assets/images/page-titles/1.webp";
import servicesbg from "../assets/images/banners/3.webp";
import aboutUserImg from "../assets/images/banners/1.webp";
import clientReviewImg1 from "../assets/images/testimonials/avatars/1.webp";
import clientReviewImg2 from "../assets/images/testimonials/avatars/2.webp";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import { Link } from "react-router-dom";
import banner_image_1 from "../assets/images/banners/1.webp";
import banner_image_2 from "../assets/images/about/who_are_we_2.jpg";
import banner_image_3 from "../assets/images/about/banner_image_3.jpg";
import banner_image_4 from "../assets/images/about/banner_image_4.jpeg";
import TechnologySlider from "../components/TechnologySlider";

function AboutUs() {
  useEffect(() => {
    // Apply background images
    document.querySelectorAll(".bg-img")?.forEach((el) => {
      const img = el.querySelector("img");
      if (img) {
        const parent = el.parentElement;
        if (parent) {
          parent.style.backgroundImage = `url(${img.src})`;
          parent.style.backgroundSize = "cover";
          parent.style.backgroundPosition = "center";
          parent.classList.add("bg-img");
          if (el.classList.contains("background-size-auto")) {
            parent.classList.add("background-size-auto");
          }
        }
        el.remove();
      }
    });
  }, []);

  const testimonials = [
    {
      id: 1,
      title:
        "It's been an excellent experience. Allianz team of consultants is a trusted partner; they took the necessary time to understand our operations and needs, which was essential for our providers and clients. They were professionals and made the right changes and adjustments to align project team with our culture and needs.",
      avatar: clientReviewImg1,
      name: "Dana Wade Sr",
      company: "allianz Inc",
    },
    {
      id: 2,
      title:
        "It's been an excellent experience. Allianz team of consultants is a trusted partner; they took the necessary time to understand our operations and needs, which was essential for our providers and clients. They were professionals and made the right changes and adjustments to align project team with our culture and needs.",
      avatar: clientReviewImg2,
      name: "Ann John",
      company: "optime Inc",
    },
  ];

  return (
    <>
      {/* Banner Section */}
      <section className="page-title-layout1 page-title-light bg-parallax bg-overlay text-center">
        <div className="bg-img">
          <img src={aboutBanner} alt="background" />
        </div>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h1 className="pagetitle-heading">About Us</h1>
              <nav>
                <ol className="breadcrumb justify-content-center mb-0">
                  <li className="breadcrumb-item">
                    <Link to="/">Home</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    About
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </section>
      {/* About us text */}
      <section className="banner-layout1 pt-40 pb-90">
        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-6 col-xl-5">
              <div className="banner-text mt-50">
                <div className="heading-layout2">
                  <h3
                    className="heading-title mb-30"
                    style={{ fontSize: 28, letterSpacing: "1px" }}
                  >
                    An Extension of Your Team for Accounting, Tax & SMSF
                    Services
                  </h3>
                  <p
                    className="heading-desc mb-30"
                    style={{
                      fontSize: 15,
                      letterSpacing: "1px",
                      fontWeight: "500",
                      color: "#333",
                    }}
                  >
                    Inscape is a specialised offshore accounting and taxation
                    services firm supporting Australian accounting practices,
                    advisory firms, and businesses. We partner with firms
                    seeking reliable, high-quality back-office support that
                    enables them to scale efficiently without compromising
                    accuracy, compliance, or client experience.
                  </p>

                  <p
                    className="heading-desc mb-30"
                    style={{
                      fontSize: 15,
                      letterSpacing: "1px",
                      fontWeight: "500",
                      color: "#333",
                    }}
                  >
                    Our mission is to work as a trusted extension of our
                    partners’ teams, helping them streamline operations, meet
                    deadlines with confidence, and scale profitably through
                    disciplined offshore accounting support.
                  </p>

                  <p
                    className="heading-desc mb-30"
                    style={{
                      fontSize: 15,
                      letterSpacing: "1px",
                      fontWeight: "500",
                      color: "#333",
                    }}
                  >
                    We believe successful outsourcing is built on people,
                    processes, and trust. Our self-driven and highly qualified
                    professionals continuously upgrade their technical and
                    practical expertise to stay aligned with evolving industry
                    standards and client expectations.
                  </p>
                </div>
                {/* /heading */}
              </div>
              {/* /.banner-text */}
            </div>
            {/* /.col-xl-5 */}
            <div className="col-sm-12 col-md-12 col-lg-6 col-xl-7">
              <div className="banner-img animated-arrow-hover mt-50">
                <img
                  src={aboutUserImg}
                  alt="about"
                  className="w-100"
                  loading="lazy"
                  style={{
                    borderRadius: "10px",
                    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px;",
                  }}
                />
                <svg
                  className="animated-arrow rotate-90"
                  xmlns="http://www.w3.org/2000/svg"
                  width={160}
                  height={160}
                  viewBox="0 0 101.7 101.7"
                >
                  <g fill="none" stroke="currentColor" strokeWidth={6}>
                    <path d="m.7 101 100-100" strokeLinejoin="round" />
                    <path
                      d="M.7 1h100"
                      strokeWidth={9}
                      strokeLinejoin="round"
                    />
                    <path
                      d="M100.7 1v100"
                      strokeWidth={9}
                      strokeLinejoin="round"
                    />
                  </g>
                </svg>
              </div>
              {/* /.banner-img */}
            </div>
            {/* /.col-xl-6 */}
          </div>
        </div>
      </section>
      <section
        className="banner-layout1 pt-40 pb-0"
        style={{ marginTop: "-100px" }}
      >
        <div className="container">
          <div className="row row-has-bg">
            <div className="col-sm-12 col-md-12 col-lg-6 col-xl-6">
              <div className="banner-img animated-arrow-hover mt-50 mx-0">
                <img
                  src={banner_image_3}
                  alt="about"
                  className="w-100"
                  loading="lazy"
                  style={{
                    borderRadius: "10px",
                    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px;",
                  }}
                />
                <svg
                  className="animated-arrow rotate-90"
                  xmlns="http://www.w3.org/2000/svg"
                  width={160}
                  height={160}
                  viewBox="0 0 101.7 101.7"
                >
                  <g fill="none" stroke="currentColor" strokeWidth={6}>
                    <path d="m.7 101 100-100" strokeLinejoin="round" />
                    <path
                      d="M.7 1h100"
                      strokeWidth={9}
                      strokeLinejoin="round"
                    />
                    <path
                      d="M100.7 1v100"
                      strokeWidth={9}
                      strokeLinejoin="round"
                    />
                  </g>
                </svg>
              </div>
            </div>
            <div className="col-sm-12 col-md-12 col-lg-6 col-xl-5 offset-xl-1">
              <div className="banner-text mt-50 mw-500">
                <div className="heading-layout2">
                  <p
                    className="heading-desc mb-30"
                    style={{
                      fontSize: 15,
                      letterSpacing: "1px",
                      fontWeight: "500",
                      color: "#333",
                    }}
                  >
                    Our team works exclusively in the Australian accounting
                    ecosystem, providing deep technical support across
                    accounting, taxation, SMSF compliance, and business
                    reporting. We focus on the core of accounting and tax,
                    including detailed interpretation of legislation,
                    application of accounting standards, and preparation of
                    structured working papers that make review and lodgement
                    seamless.
                  </p>

                  <p
                    className="heading-desc mb-30"
                    style={{
                      fontSize: 15,
                      letterSpacing: "1px",
                      fontWeight: "500",
                      color: "#333",
                    }}
                  >
                    At Inscape, quality and consistency are not optional. We
                    follow structured workflows and robust quality management
                    systems to ensure accurate, dependable, and timely delivery
                    across every engagement.
                  </p>
                </div>
                <ul className="list-items-layout1 d-inline-flex flex-column list-unstyled mb-30">
                  <li className="list-item fw-bold">
                    Small and medium-sized entities
                  </li>
                  <li className="list-item fw-bold">
                    Complex business structures
                  </li>
                  <li className="list-item fw-bold">
                    Multi-entity and group reporting
                  </li>
                  <li className="list-item fw-bold">
                    Compliance-heavy engagements requiring precision and
                    consistency
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="fancyboxs-layout4 pt-50 pb-50 border-bottom">
        <div className="container-fluid">
          <div
            className="heading-layout2"
            style={{
              marginLeft: "40px",
              marginBottom: "0",
            }}
          >
            <h2 className="heading-subtitle">What We Do</h2>
            <h3
              className="heading-title"
              style={{
                fontSize: "15px",
              }}
            >
              Our decade-long experience ensures consistent quality, technical
              accuracy, and dependable delivery across every engagement.
            </h3>
          </div>

          <div className="row fancybox-wrapper align-items-center justify-content-center">
            {/* fancybox item #1 */}
            <div className="col-sm-12 col-md-6 col-lg-4">
              <div className="fancybox-item">
                <div className="fancybox-body">
                  <p className="fancybox-desc">
                    We act as an extension of our clients’ internal teams,
                    handling time-intensive processing while maintaining
                    transparency and control.
                  </p>
                </div>
              </div>
            </div>

            {/* fancybox item #1 */}
            <div className="col-sm-12 col-md-6 col-lg-4">
              <div className="fancybox-item">
                <div className="fancybox-body">
                  <p className="fancybox-desc">
                    Our services are designed to integrate smoothly into your
                    existing workflows, systems, and software platforms.
                  </p>
                </div>
              </div>
            </div>

            {/* fancybox item #1 */}
            <div className="col-sm-12 col-md-6 col-lg-4">
              <div className="fancybox-item">
                <div className="fancybox-body">
                  <p className="fancybox-desc">
                    From day-to-day bookkeeping to year-end financial
                    statements, tax returns, BAS/IAS, and SMSF processing, we
                    deliver work that is accurate, compliant, and review ready.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Numbering Section */}
      <section className="counters border-top pt-80 pb-50">
        <div className="container">
          <div className="row">
            {/* counter item #1 */}
            <div className="col-sm-6 col-md-6 col-lg-3">
              <div className="counter-item">
                <div className="d-flex align-items-center">
                  <h4 className="counter">
                    <span className="counter-number">
                      {localStorage.getItem("number_client") || 0} +
                    </span>
                  </h4>
                  <div className="counter-icon">
                    <i className="icon-arrow-up-right" />
                  </div>
                </div>
                <p className="counter-desc">
                  Trusted by a growing network of satisfied businesses across
                  Australia
                </p>
              </div>
              {/* /.counter-item */}
            </div>
            {/* /.col-lg-3 */}
            {/* counter item #2 */}
            <div className="col-sm-6 col-md-6 col-lg-3">
              <div className="counter-item">
                <div className="d-flex align-items-center">
                  <h4 className="counter">
                    <span className="counter-number">
                      {localStorage.getItem("number_hours") || 0} +
                    </span>
                  </h4>
                  <div className="counter-icon">
                    <i className="icon-arrow-up-right" />
                  </div>
                </div>
                <p className="counter-desc">
                  Dedicated service hours delivered with reliability and
                  efficiency
                </p>
              </div>
              {/* /.counter-item */}
            </div>
            {/* /.col-lg-3 */}
            {/* counter item #3 */}
            <div className="col-sm-6 col-md-6 col-lg-3">
              <div className="counter-item">
                <div className="d-flex align-items-center">
                  <h4 className="counter">
                    <span className="counter-number">
                      {localStorage.getItem("number_no_of_exp") || 0} +
                    </span>
                  </h4>
                  <div className="counter-icon">
                    <i className="icon-arrow-up-right" />
                  </div>
                </div>
                <p className="counter-desc">
                  Compliance Deliverables Completed
                </p>
              </div>
              {/* /.counter-item */}
            </div>
            {/* /.col-lg-3 */}
            {/* counter item #4 */}
            <div className="col-sm-6 col-md-6 col-lg-3">
              <div className="counter-item">
                <div className="d-flex align-items-center">
                  <h4 className="counter">
                    <span className="counter-number">
                      {localStorage.getItem("number_team_member") || 0} +
                    </span>
                  </h4>
                  <div className="counter-icon">
                    <i className="icon-arrow-up-right" />
                  </div>
                </div>
                <p className="counter-desc">
                  Skilled and experienced professionals committed to excellence
                </p>
              </div>
              {/* /.counter-item */}
            </div>
            {/* /.col-lg-3 */}
          </div>
          {/* /.row */}
        </div>
        {/* /.container */}
      </section>

      {/* Our Approach */}
      <section className="banner-layout1 pt-40 pb-20">
        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-6 col-xl-5">
              <div className="banner-text mt-50">
                <div className="heading-layout2">
                  <h3 className="heading-title mb-30" style={{ fontSize: 28 }}>
                    Our Approach
                  </h3>
                  <p
                    className="heading-desc mb-30"
                    style={{ fontSize: 15, letterSpacing: "1px" }}
                  >
                    We place strong emphasis on turnaround times, consistency,
                    and communication — ensuring our clients can confidently
                    meet deadlines and regulatory obligations.
                  </p>

                  <p
                    className="heading-desc mb-30"
                    style={{ fontSize: 15, letterSpacing: "1px" }}
                  >
                    At Inscape, quality is non-negotiable. Every engagement
                    follows a structured delivery model supported by:
                  </p>

                  <ul className="list-items-layout1 d-inline-flex flex-column list-unstyled mb-30">
                    <li className="list-item fw-bold">
                      Small and medium-sized entities
                    </li>
                    <li className="list-item fw-bold">
                      Complex business structures
                    </li>
                    <li className="list-item fw-bold">
                      Multi-entity and group reporting
                    </li>
                    <li className="list-item fw-bold">
                      Compliance-heavy engagements requiring precision and
                      consistency
                    </li>
                  </ul>
                </div>
                {/* /heading */}
              </div>
              {/* /.banner-text */}
            </div>
            {/* /.col-xl-5 */}
            <div className="col-sm-12 col-md-12 col-lg-6 col-xl-7">
              <div className="banner-img animated-arrow-hover mt-50">
                <img
                  src={banner_image_4}
                  alt="about"
                  className="w-100"
                  loading="lazy"
                  style={{
                    borderRadius: "10px",
                    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px;",
                  }}
                />
                <svg
                  className="animated-arrow rotate-90"
                  xmlns="http://www.w3.org/2000/svg"
                  width={160}
                  height={160}
                  viewBox="0 0 101.7 101.7"
                >
                  <g fill="none" stroke="currentColor" strokeWidth={6}>
                    <path d="m.7 101 100-100" strokeLinejoin="round" />
                    <path
                      d="M.7 1h100"
                      strokeWidth={9}
                      strokeLinejoin="round"
                    />
                    <path
                      d="M100.7 1v100"
                      strokeWidth={9}
                      strokeLinejoin="round"
                    />
                  </g>
                </svg>
              </div>
              {/* /.banner-img */}
            </div>
            {/* /.col-xl-6 */}
          </div>
        </div>
      </section>

      {/* Our Vision and value */}
      <section className="team-layout2 pt-40 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-12 col-md-12 col-lg-6">
              <div className="heading-layout2">
                <h3 className="heading-title">Our Vision</h3>
                <p className="heading-desc mb-30">
                  To become a trusted offshore accounting partner for Australian
                  firms by consistently delivering technically sound, compliant,
                  and reliable services that support growth, efficiency, and
                  long-term success.
                </p>
                <a
                  // href="team.html"
                  className="btn btn-primary btn-link btn-underlined arrow-hover-flip-up mb-50"
                >
                  <span>Our Leadership Team</span>
                  <svg
                    className="arrow-flip"
                    enableBackground="new 0 0 64 64"
                    viewBox="0 0 64 64"
                    width={10}
                    height={10}
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g className="arrow-flip-path-1">
                      <path
                        d="m56 6h-48c-1.104 0-2 .896-2 2s.896 2 2 2h43.171l-44.585 44.586c-.781.781-.781 2.047 0 2.828.391.391.902.586 1.414.586s1.024-.195 1.414-.586l44.586-44.586v43.172c0 1.104.896 2 2 2s2-.896 2-2v-48c0-1.104-.896-2-2-2z"
                        fill="currentColor"
                      />
                    </g>
                    <g className="arrow-flip-path-2">
                      <path
                        d="m56 6h-48c-1.104 0-2 .896-2 2s.896 2 2 2h43.171l-44.585 44.586c-.781.781-.781 2.047 0 2.828.391.391.902.586 1.414.586s1.024-.195 1.414-.586l44.586-44.586v43.172c0 1.104.896 2 2 2s2-.896 2-2v-48c0-1.104-.896-2-2-2z"
                        fill="currentColor"
                      />
                    </g>
                  </svg>
                </a>
              </div>
              {/* /heading */}
            </div>
            {/* /.col-lg-4 */}
            <div className="col-12 col-md-12 col-lg-6">
              <div className="banner-text mw-500">
                <div className="heading-layout2">
                  <h3 className="heading-title">Our Values</h3>
                </div>
                <ul className="list-items-layout1 d-inline-flex flex-column list-unstyled mb-30">
                  <li className="list-item fw-bold">
                    Integrity - We do what is right, always
                  </li>
                  <li className="list-item fw-bold">
                    Accuracy - Precision and compliance in every deliverable
                  </li>
                  <li className="list-item fw-bold">
                    Accountability - Ownership of work and outcomes
                  </li>
                  <li className="list-item fw-bold">
                    Professional Excellence - Continuous improvement and
                    learning
                  </li>
                  <li className="list-item fw-bold">
                    Partnership - Working as an extension of our clients' teams
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        {/* /.container */}
      </section>

      {/* Why Clients Choose Inscape */}
      <section
        className="banner-layout1 pt-40 pb-80"
        style={{ marginTop: "-100px" }}
      >
        <div className="container">
          <div className="row row-has-bg">
            <div className="col-sm-12 col-md-12 col-lg-6 col-xl-6">
              <div className="banner-img animated-arrow-hover mt-50 mx-0">
                <img
                  src={banner_image_2}
                  alt="about"
                  className="w-100"
                  loading="lazy"
                  style={{
                    borderRadius: "10px",
                    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px;",
                  }}
                />
                <svg
                  className="animated-arrow rotate-90"
                  xmlns="http://www.w3.org/2000/svg"
                  width={160}
                  height={160}
                  viewBox="0 0 101.7 101.7"
                >
                  <g fill="none" stroke="currentColor" strokeWidth={6}>
                    <path d="m.7 101 100-100" strokeLinejoin="round" />
                    <path
                      d="M.7 1h100"
                      strokeWidth={9}
                      strokeLinejoin="round"
                    />
                    <path
                      d="M100.7 1v100"
                      strokeWidth={9}
                      strokeLinejoin="round"
                    />
                  </g>
                </svg>
              </div>
            </div>
            <div className="col-sm-12 col-md-12 col-lg-6 col-xl-5 offset-xl-1">
              <div className="banner-text mt-50 mw-500">
                <div className="heading-layout2">
                  <h3 className="heading-title mb-30" style={{ fontSize: 28 }}>
                    Why Clients Choose Inscape
                  </h3>
                </div>
                <ul className="list-items-layout1 d-inline-flex flex-column list-unstyled mb-30">
                  <li className="list-item fw-bold">
                    Big 4-led standards applied to every engagement
                  </li>
                  <li className="list-item fw-bold">
                    Exclusive focus on Australian accounting and tax
                  </li>
                  <li className="list-item fw-bold">
                    Technically strong teams with practical industry exposure
                  </li>
                  <li className="list-item fw-bold">
                    Scalable offshore delivery without fixed overheads
                  </li>
                  <li className="list-item fw-bold">
                    Secure and confidential processes
                  </li>
                  <li className="list-item fw-bold">
                    Long-term partnership mindset, not transactional outsourcing
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <TechnologySlider />
    </>
  );
}

export default AboutUs;
